<template>
<span>
    Manage treatments
  </span>
</template>
<script>

export default {
  name: "ManageTreatments",
  props: {
    value: Object,
    index: Number
  },
  created: function () {
      // this is always valid as one feature has to be selected
      this.$emit("step-is-valid", 1);
  },
  data: function () {
    return {
    };
  },
};
</script>